import { createSelector } from 'reselect';
import { parentPath, appendPath, getValue } from '@truqc/content-path';
import { getContent, getStaticContent, getFormat } from './simpleSelectors';
import newPathSelector from './newPathSelector';
const getPropsValue = (state, props) => props.value;
export default createSelector([getContent, getStaticContent, newPathSelector, getFormat, getPropsValue], (content, staticContent, contentPath, format, propsValue) => {
  let value;

  // in some cases, the value is precomputed by other components
  // and stored directly in the props.  So, look for that case.
  if (propsValue !== undefined) {
    return propsValue;
  }

  // if `value` or `source` are defined in the format, then those are the primary
  // source of value.
  if (format && format.value !== undefined) {
    ({
      value
    } = format);
    return value;
  }
  if (format && format.source !== undefined) {
    const {
      source
    } = format;
    return source;
  }

  // check content
  if (format && format.contentPath !== undefined) {
    // only get a value from content if the format contains a contentPath.
    value = getValue(contentPath, content);
    if (value !== undefined) {
      return value;
    }
    // also check static content
    value = getValue(contentPath, staticContent);
    if (value !== undefined) {
      return value;
    }
  }

  // look for default values.
  if (format && format.defaultValueContentPath !== undefined) {
    const {
      defaultValueContentPath
    } = format;
    let parent = contentPath;
    if (format.contentPath && format.contentPath.length > 0) {
      // we need to get parent of current contentPath
      parent = parentPath(contentPath);
    }
    const defaultPath = appendPath(parent, defaultValueContentPath);

    // only get a value from content if the format contains a contentPath.
    value = getValue(defaultPath, content);
    if (value !== undefined) {
      return value;
    }
    // also check static content
    value = getValue(defaultPath, staticContent);
    if (value !== undefined) {
      return value;
    }
  }
  // check for a `defaultValue` defined.
  if (format && format.defaultValue !== undefined) {
    return format.defaultValue;
  }
  return undefined;
});